import { render, staticRenderFns } from "./HotelItem.vue?vue&type=template&id=a71a8050&scoped=true&"
import script from "./HotelItem.vue?vue&type=script&lang=js&"
export * from "./HotelItem.vue?vue&type=script&lang=js&"
import style0 from "./HotelItem.vue?vue&type=style&index=0&id=a71a8050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a8050",
  null
  
)

export default component.exports